module.exports = __webpack_public_path__ + "img/logo-sm.af48fb81.png";